import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class CustomDateHelper {
  private readonly DELIMITER = '-';

  getNgbDate(value: string): NgbDateStruct {
    const date: string[] = value.split(this.DELIMITER);
    return {
      day: +date[2],
      month: +date[1],
      year: +date[0],
    };
  }
}
